"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessageWithIntl = void 0;
const thirdPartyLogin_1 = require("../constants/thirdPartyLogin");
const messages_1 = __importDefault(require("../messages"));
const getErrorMessageWithIntl = ({ thirdPartyLoginProps = {}, intl }) => {
    if (!intl)
        return null;
    const { type, errors } = thirdPartyLoginProps;
    if (type === thirdPartyLogin_1.EHR_MYCHART) {
        const [error] = errors;
        switch (error) {
            // Various errors may be handled differently in the future,
            // but for now, treat them as a general error.
            case thirdPartyLogin_1.ERROR.ERROR_EHR_INVALID_PID:
            case thirdPartyLogin_1.ERROR.ERROR_EHR_INVALID_ACCESS_TOKEN:
            case thirdPartyLogin_1.ERROR.ERROR_EHR_INVALID_SOURCE_SYSTEM:
            case thirdPartyLogin_1.ERROR.ERROR_EHR_NOT_AUTHORIZED_BY_USER:
            case thirdPartyLogin_1.ERROR.ERROR_EHR_LOGIN:
            default: {
                return {
                    description: intl.formatMessage(messages_1.default.mychartLoginErrorDescription),
                    action: intl.formatMessage(messages_1.default.mychartLoginErrorAction)
                };
            }
        }
    }
    return null;
};
exports.getErrorMessageWithIntl = getErrorMessageWithIntl;
//# sourceMappingURL=getErrorMessageWithIntl.js.map